document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-lac-related-slider]').forEach(function (slider) {
    const track = slider.querySelector('[data-lac-related-track]');
    const prev = slider.querySelector('[data-lac-related-prev]');
    const next = slider.querySelector('[data-lac-related-next]');

    if (!track || !prev || !next) return;

    function getScrollAmount() {
      const card = track.querySelector('.lac-related-card');
      if (!card) return track.clientWidth;

      const gap = parseFloat(window.getComputedStyle(track).gap) || 0;
      return card.offsetWidth + gap;
    }

    function updateArrows() {
      const maxScrollLeft = track.scrollWidth - track.clientWidth;
      const currentScroll = track.scrollLeft;

      prev.disabled = currentScroll <= 5;
      next.disabled = currentScroll >= maxScrollLeft - 5;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({
        left: -getScrollAmount(),
        behavior: 'smooth'
      });
    });

    next.addEventListener('click', function () {
      track.scrollBy({
        left: getScrollAmount(),
        behavior: 'smooth'
      });
    });

    track.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);

    updateArrows();
  });
});